export const text = {
  title: 'Change Password',
  subtitle: 'Update your account password',
  submit: 'Change Password',
  current: 'Current Password',
  new: 'New Password',
  confirm: 'Confirm New Password',
  unavailable: 'Password change is only available for email accounts.',
  action: 'Change password',
};
